import { Pagination, Tooltip } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { FaEye, FaFile } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Input, Table } from "reactstrap";
import { formatNumberWithCommas } from "../../helpers/helpers";
import useRowSelection from "../../views/Admin/customHooks/useRowSelection";
import NotFoundDataUI from "../cards/NotFoundDataUI";
const PurchaseOrderTable = ({
  data,
  setSelectedData,
  user,
  page,
  setPage,
  totalPages,
  pageSize,
  setPageSize,
  setSelectedItem,
  searchValue,
  onClearSearch,
}) => {
  const history = useHistory();
  const {
    selectedRows,
    handleCheckboxChange,
    handleSelectAll,
    handleViewSelected,
  } = useRowSelection();
  // Handle selection state
  useEffect(() => {
    let selected = handleViewSelected(data);
    setSelectedData(selected);
  }, [selectedRows]);
  // Handle pagination + filter logic
  useEffect(() => {
    const storedStatus = localStorage.getItem("selectedStatus") || "";
    const storedPage =
      parseInt(localStorage.getItem("purchaseOrderPage"), 10) || 1;
    setSelectedItem(storedStatus);
    if (storedPage <= totalPages) {
      setPage(storedPage);
    } else if (totalPages > 0) {
      setPage(totalPages);
    }
    if (searchValue?.length > 1) {
      setPage(1);
    }
  }, [data, pageSize, searchValue]);
  return (
    <div>
      <Table
        responsive
        hover
        bordered
        className="mb-0"
        style={{
          fontSize: "14px",
          overflow: "hidden",
          border: "1px solid #e2e8f0"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#00509d", color: "white" }}>
            {(user?.role === "Admin" || user?.role === "Super-admin") && (
              <th className="text-center" style={{ borderBottom: "none" }}>
                <Input
                  type="checkbox"
                  onChange={(e) => handleSelectAll(e, data)}
                  checked={selectedRows.length === data.length && data.length > 0}
                  className="cursor-pointer"
                />
              </th>
            )}
            <th className="text-center" style={{ borderBottom: "none" }}>Date</th>
            <th className="text-center" style={{ borderBottom: "none" }}>PO ID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>QB ID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Vendor</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Amount</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Status</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {data?.length > 0 ? (
            data.map((row, index) => (
              <tr
                key={index}
                className="align-middle"
                style={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                  borderBottom: "1px solid #f1f5f9"
                }}
              >
                {(user?.role === "Admin" || user?.role === "Super-admin") && (
                  <td className="text-center">
                    <Input
                      type="checkbox"
                      onChange={(e) => handleCheckboxChange(e, row)}
                      checked={selectedRows.includes(row._id)}
                      className="cursor-pointer"
                    />
                  </td>
                )}

                <td className="text-center text-muted ">
                  {moment(row?.created_at).format("ll")}
                </td>

                <td className="text-center fw-bold">
                  <span className="text-primary">
                    {row?.directPO === true ? "M-" : ""}
                    {row?.id}
                  </span>
                </td>

                <td className="text-center">
                  <small className="text-black fs-12">{row?.quickbooks_id ?? "-"}</small>
                </td>

                <td className="text-center fw-semibold">
                  {row?.vendor?.company || "N/A"}
                </td>

                <td className="text-center fw-bold text-dark">
                  ${formatNumberWithCommas(parseFloat(row?.total)?.toFixed(2))}
                </td>

                <td className="text-center">
                  {row?.purchaseOrderStatus === "cancel" ? (
                    <span className="user-badge bg-danger-soft">
                      Cancelled
                    </span>
                  ) : (
                    <span className="user-badge bg-primary-soft text-capitalize">
                      {row?.purchaseOrderStatus}
                    </span>
                  )}
                </td>

                <td className="text-center">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <Tooltip title="View Details">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() =>
                          history.push({
                            pathname: `/admin/update-purchase-orders-details/${row?._id}`,
                            state: {
                              obj: row,
                              vendor: {
                                billing: [row?.vendor],
                                id: row?.vendorOrderId,
                                _id: row?.vendorId,
                              },
                            },
                          })
                        }
                      >
                        <FaEye className="text-primary" size={16} />
                      </Button>
                    </Tooltip>

                    <Tooltip title="View PDF">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() =>
                          history.push({
                            pathname: `/admin/generate-purchase-orders-details/${row?._id}`,
                            state: {
                              obj: row,
                              id: row?.id,
                              vendor: {
                                billing: [row?.vendor],
                                id: row?.vendorOrderId,
                                _id: row?.vendorId,
                              },
                            },
                          })
                        }
                      >
                        <FaFile className="text-danger" size={16} />
                      </Button>
                    </Tooltip>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={(user?.role === "Admin" || user?.role === "Super-admin") ? 8 : 7} className="text-center py-5">
                <NotFoundDataUI 
                  message={"No Purchase Orders found!"} 
                  onClearSearch={onClearSearch}
                />
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {data?.length > 0 && (
        <div className="d-flex justify-content-end mt-3 px-2">
          <Pagination
            size="small"
            current={page}
            total={totalPages}
            onChange={(value) => {
              localStorage.setItem("purchaseOrderPage", value);
              setPage(value);
            }}
            pageSize={pageSize}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setPage(1);
            }}
            pageSizeOptions={['10', '25', '50', '100']}
          />
        </div>
      )}
    </div>
  );
};

export default PurchaseOrderTable;
